const createBeep = (
  frequency: number,
  duration: number,
  type: OscillatorType = 'sine'
): void => {
  try {
    const AudioContextCtor =
      window.AudioContext ||
      (window as Window & { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;

    if (!AudioContextCtor) return;

    const ctx = new AudioContextCtor();
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);

    oscillator.type = type;
    oscillator.frequency.setValueAtTime(frequency, ctx.currentTime);
    gainNode.gain.setValueAtTime(0.15, ctx.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);

    oscillator.start(ctx.currentTime);
    oscillator.stop(ctx.currentTime + duration);

    oscillator.onended = () => {
      void ctx.close();
    };
  } catch {
    // Silently ignore audio errors (e.g. user hasn't interacted with page yet)
  }
};

export const playStartSound = (): void => {
  createBeep(880, 0.15);
};

export const playStopSound = (): void => {
  createBeep(440, 0.2);
};
